import React from 'react';
import './Footer.css';  // We'll create this next

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>&copy; {new Date().getFullYear()} Filesig Software Solutions. Filesig Pte. Ltd. All rights reserved.</p>
        
        <div className="footer-nav-row">
          <a href="https://www.filesig.co.uk">Filesig Software Solutions</a>
          <a href="https://www.firewalli.com">Firewalli</a>
          <a href="https://www.securityexceptions.com">Security Risk and Exception Manager</a>
          <a href="https://www.securecodecards.com">Secure Code Cards</a>
          <a href="https://www.aisectraining.com">AI Security Training</a>
          <a href="https://www.saassecurityscore.com">SaaS Security Score</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 
